import { jsx as _jsx } from "react/jsx-runtime";
// web/src/rendering/components/layouts/Grid.tsx
// Layout leaf: N-column CSS grid. Children are render blocks, dispatched via
// the shared Renderer — recursion is free.
import { Renderer } from "../../Renderer";
const COL_CLASSES = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-3",
    4: "grid-cols-2 md:grid-cols-4",
};
const GAP_CLASSES = {
    2: "gap-2",
    3: "gap-3",
    4: "gap-4",
    6: "gap-6",
};
export function Grid({ columns = 2, gap = 4, children = [] }) {
    const cols = COL_CLASSES[columns] ?? COL_CLASSES[2];
    const g = GAP_CLASSES[gap] ?? GAP_CLASSES[4];
    return (_jsx("div", { className: `grid ${cols} ${g} mt-3`, children: children.map((child, i) => (_jsx(Renderer, { block: child }, i))) }));
}
